export default class AssistantAPICommand {
  public message?: string;
  public userId?: string;
  public previousResponseId?: string;
  public currentRoute?: string;
}
